import React, { useEffect, useState } from 'react';
import { client } from '../sanityClient';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    client
      .fetch(`*[_type == "post" && defined(slug.current)] | order(publishedAt desc){
        title,
        slug,
        publishedAt,
        summary,
        mainImage{
          asset->{
            url
          }
        }
      }`)
      .then(setPosts)
      .catch(console.error);
  }, []);

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 16px' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '32px' }}>Blogg</h1>

      <div style={{
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  gap: '32px',
}}>
  {posts.map((post) => (
    <Link
      key={post.slug.current}
      to={`/blog/${post.slug.current}`}
      style={{
        display: 'block',
        width: '100%',
        maxWidth: '350px',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        backgroundColor: '#fff',
        color: 'inherit',
        textDecoration: 'none',
        transition: 'box-shadow 0.2s ease-in-out',
      }}
      onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)')}
      onMouseOut={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)')}
    >
      <div style={{ height: '180px', overflow: 'hidden', backgroundColor: '#f5f5f5' }}>
        <img
          src={post.mainImage?.asset?.url || ''}
          alt={post.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: post.mainImage?.asset?.url ? 'cover' : 'none',
            backgroundColor: '#fff',
          }}
        />
      </div>

      <div style={{ padding: '16px' }}>
        <h2 style={{ fontSize: '1.25rem', margin: '0 0 8px' }}>{post.title}</h2>
        <p style={{ fontSize: '0.875rem', color: '#777', marginBottom: '8px' }}>
          {new Date(post.publishedAt).toLocaleDateString('nb-NO', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>
        <p style={{ fontSize: '1rem', color: '#444' }}>{post.summary}</p>
      </div>
    </Link>
  ))}
</div>
    </div>
  );
};

export default Blog;
